var Handlebars = require("../../../../handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"progress-bar\"></div>\n<div class=\"export-tools dropup ol-control\"></div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// /~/eoxc/src/contrib/OpenLayers/OpenLayersMapView.hbs
// module id = 2031
// module chunks = 0